import { render } from "./EditConfigLanguages.vue?vue&type=template&id=c88c8d96"
import script from "./EditConfigLanguages.vue?vue&type=script&lang=js"
export * from "./EditConfigLanguages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__